import { emailLink } from '@ps/web-core-utils';

import StarsLink from '../StarsLink/StarsLink';

export const starsEmailLink = (text: string) => emailLink(text, StarsLink);
